"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScratchpadMessageUpdateRequestSchema = void 0;
var zod_1 = require("zod");
exports.ScratchpadMessageUpdateRequestSchema = zod_1.z.object({
    content: zod_1.z.string(),
});
